import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-navbar',
  templateUrl: './auth-navbar.component.html',
  styleUrls: ['./auth-navbar.component.css']
})
export class AuthNavbarComponent {
  /** When true, shows the back button + "Volver atrás" label. When false, shows the title string. */
  @Input() showBack: boolean = false;
  /** Title text shown on the left when showBack is false. */
  @Input() title: string = '';
  /** Emitted when the back button is clicked. */
  @Output() goBack = new EventEmitter<void>();

  production = environment.production;
  clientName = environment.clientName;

  onGoBack(): void {
    this.goBack.emit();
  }
}
